import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';


const Script = () => (
  <Head>
    <script
      async
      custom-element="amp-form"
      key="amp-form"
      src="https://cdn.ampproject.org/v0/amp-form-0.1.js"
    />
    <script
      async
      custom-element="amp-bind"
      src="https://cdn.ampproject.org/v0/amp-bind-0.1.js"
    />
  </Head>
);

export const AmpForm = ({ children }) => (
  <>
    <Script />
    {children}
  </>
);

AmpForm.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
